class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  open() {
    this.mainDetailsToggle.addAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.detailsDisclosures = document.querySelectorAll('header-menu details');

    this.content = this.querySelector('.mega-menu__content');
    this.detailsDisclosureToggle = this.querySelector('summary');

    if (this.content) {
      this.content.addEventListener('mouseleave', (event) => {
        this.detailsDisclosureToggle.click();
        document.activeElement.blur();
      });
    }

    if (this.detailsDisclosureToggle) {
      this.detailsDisclosureToggle.addEventListener('mouseover', this.onHover.bind(this));
    }
  }

  onHover() {
    if (!this.contains(document.activeElement)) {
      this.detailsDisclosureToggle.focus();
      this.detailsDisclosureToggle.click();

      this.detailsDisclosures.forEach((detailsDisclosure) => {
        setTimeout(() => {
          if (!detailsDisclosure.parentElement.contains(document.activeElement)) {
            detailsDisclosure.removeAttribute('open');
            detailsDisclosure.querySelector('summary').setAttribute('aria-expanded', false);
          }
        });
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
